import { setSelectedAccident } from "../../../../actions/accidentDashboard";
import { changeSelectedProviderWriUser } from "../../../../actions/providers";
import {
  openEditForm,
  openRepeatForm,
  setFormsDocumentList,
  setFormsGeneralProperties,
} from "../../../../actions/formsState";
import { formBehaviourEnum } from "../../../commons/enum/formEnums";
import snackbarUtils from "../../../../utils/snackbarUtils";

const toPositiveInt = (value) => {
  const parsed = Number(value);
  return Number.isInteger(parsed) && parsed > 0 ? parsed : null;
};

const resolveTrasladoFptContext = (traslado, artContext = {}) => ({
  idSiniestro: toPositiveInt(traslado?.idSiniestro),
  nroFormulario: toPositiveInt(traslado?.nroFormulario),
  idArt: toPositiveInt(traslado?.idArt) ?? toPositiveInt(artContext.idArt),
  artName: traslado?.artName || artContext.artName || null,
});

export const buildAccidentFromTraslado = (traslado, artContext = {}) => {
  const context = resolveTrasladoFptContext(traslado, artContext);
  return {
    idSiniestro: context.idSiniestro,
    mlCloudCoreArtId: context.idArt,
    art: context.artName,
    siniestro: traslado?.numeroHistoriaClinica || traslado?.siniestro,
    documento: traslado?.dni ?? traslado?.documentoTrabajador,
    apellidoTrabajador: traslado?.apellidoTrabajador,
    nombreTrabajador: traslado?.nombreTrabajador,
    prestadorId: traslado?.prestadorId,
  };
};

export const openAccidentFromTraslado = (dispatch, accident) => {
  if (accident.prestadorId != null) {
    dispatch(changeSelectedProviderWriUser(accident.prestadorId));
  }
  dispatch(setSelectedAccident(accident));
};

export const openFptFromTraslado = (dispatch, traslado, openFpt, artContext = {}) => {
  const context = resolveTrasladoFptContext(traslado, artContext);
  const accident = buildAccidentFromTraslado(traslado, artContext);

  if (!context.idSiniestro || !context.idArt) {
    snackbarUtils.error("No se pudo abrir el formulario de pedido de traslado.");
    return;
  }

  if (!context.nroFormulario) {
    snackbarUtils.error("No se encontró el formulario de pedido de traslado.");
    return;
  }

  openAccidentFromTraslado(dispatch, accident);
  openFpt(dispatch, accident, traslado, context.nroFormulario);
};

const setFptTrasladoProperties = (dispatch, accident, traslado, nroFormulario) => {
  // Desde traslados no hay contexto de siniestro navegable: sin esto queda la
  // lista de documentos de la última visita al dashboard.
  dispatch(setFormsDocumentList(null));
  dispatch(
    setFormsGeneralProperties({
      idSiniestro: accident.idSiniestro,
      idArt: accident.mlCloudCoreArtId,
      artName: accident.art,
      documento: accident.documento || traslado?.dni || traslado?.documentoTrabajador,
      trabajador: traslado?.trabajador,
      apellidoTrabajador: accident.apellidoTrabajador,
      nombreTrabajador: accident.nombreTrabajador,
      numeroHistoriaClinica: accident.siniestro,
      nroFormulario,
    }),
  );
};

const getSelectedFptDocument = (accident, traslado, nroFormulario) => ({
  nroFormulario,
  documento: accident.documento || traslado?.dni || traslado?.documentoTrabajador,
});

export const openFptReadOnlyFromTraslado = (dispatch, accident, traslado, nroFormulario) => {
  setFptTrasladoProperties(dispatch, accident, traslado, nroFormulario);
  dispatch(
    openEditForm(
      "fpt",
      formBehaviourEnum.MODIFY_ACCIDENT_DOCUMENT,
      getSelectedFptDocument(accident, traslado, nroFormulario),
      { readOnly: true },
    ),
  );
};

export const openFptEditableFromTraslado = (dispatch, accident, traslado, nroFormulario) => {
  setFptTrasladoProperties(dispatch, accident, traslado, nroFormulario);
  dispatch(
    openEditForm(
      "fpt",
      formBehaviourEnum.MODIFY_ACCIDENT_DOCUMENT,
      getSelectedFptDocument(accident, traslado, nroFormulario),
      { editable: true },
    ),
  );
};

export const openFptDuplicateFromTraslado = (dispatch, accident, traslado, nroFormulario) => {
  if (traslado?.siniestroEsRechazado) {
    snackbarUtils.error("El siniestro se encuentra rechazado. No puede solicitar traslado.");
    return;
  }
  if (traslado?.siniestroTieneAltaMedica) {
    snackbarUtils.error("El siniestro tiene alta médica. No puede solicitar traslado.");
    return;
  }
  setFptTrasladoProperties(dispatch, accident, traslado, nroFormulario);
  dispatch(openRepeatForm("fpt"));
};
